import { Component, input, output } from '@angular/core';
import { ButtonComponent } from '@purolator/ui-kit-angular';
import { TranslatePipe } from '../../../../core/i18n';

/**
 * Review & Pay footer actions: Back, Cancel Shipment, and Proceed To Payment.
 * While checkout is active, all footer actions are disabled to prevent leave/cancel races.
 * Cancel remains presentational otherwise; Proceed emits for the page to enforce terms + payment.
 */
@Component({
  selector: 'app-review-and-pay-actions',
  imports: [ButtonComponent, TranslatePipe],
  templateUrl: './review-and-pay-actions.html',
  styleUrl: './review-and-pay-actions.scss',
})
export class ReviewAndPayActions {
  /** Disables duplicate submissions while create or hosted checkout is active. */
  readonly checkoutActive = input(false);
  /** Emitted when the customer clicks Back (page shows leave warning before navigating). */
  readonly backRequested = output<void>();
  /** Emitted when the customer clicks Cancel Shipment. */
  readonly cancelRequested = output<void>();
  /** Emitted when the customer clicks Proceed To Payment. */
  readonly proceed = output<void>();

  /**
   * Opens the cancel-shipment confirmation modal on the page.
   */
  protected onCancel(): void {
    if (this.checkoutActive()) {
      return;
    }
    this.cancelRequested.emit();
  }

  /**
   * Asks the page to confirm before leaving Review & Pay for Service.
   */
  protected onBack(): void {
    if (this.checkoutActive()) {
      return;
    }
    this.backRequested.emit();
  }

  /**
   * Asks the page to validate terms and continue to payment.
   */
  protected onProceed(): void {
    if (this.checkoutActive()) {
      return;
    }
    this.proceed.emit();
  }
}
